import axios from 'axios'
import { token } from '../_config/config'

export default function setup () {
  axios.interceptors.response.use(
    response => {
      return response
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  axios.interceptors.request.use(
    config => {
      if (token) {
        config.headers['AIS-TOKEN'] = token
      }

      config.headers['Content-Type'] = 'application/json'
      return config
    },
    error => {
      Promise.reject(error)
    }
  )
}
